import PropTypes from 'prop-types';

const {
  object,
} = PropTypes;

export default object;
